export default __webpack_public_path__ + "static/CenturyExpanded-Italic-c8d947e1d900a11bbb8f1940f7b29051.woff2";